module.exports = __webpack_public_path__ + "assets/fonts/Gordita-Regular.f87c2dc9db1b15131558136d7ad9d1fa.woff2";